import { SnMapClusterPoint } from '@lib/api';
import { SnLocation } from '@lib/api/entities';
import { colorIsDark } from '@lib/common/helpers';
import { FsMap, FsMapMarker, IMapMarkerOptions } from '@lib/geo/map';
import { COLORS } from '@lib/ui/theme';

import { FontAwesomeIconMapper } from '../../../../geo/helpers/src/lib/markers/font-awesome-icon-mapper';

import AdvancedMarkerElement = google.maps.marker.AdvancedMarkerElement;

export class FsLocationMapMarker extends FsMapMarker {
  constructor(public map: FsMap, public location: SnLocation, public cluster?: SnMapClusterPoint) {
    const mapper = new FontAwesomeIconMapper();
    super(
      map,
      {
        id: location?.id || cluster?.id?.toString(),
        lonLat: cluster ? cluster.geometry.coordinates : location.geometry.coordinates,
        title: location ? location.name : null,
        collisionBehavior: google.maps.CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY,
        clickable: true,
        color: location?.type?.color || '#fff',
        icon: cluster
          ? { name: 'esri-icon-organization' }
          : {
              color: location?.type.color,
              fontSet: 'fas',
              fontIcon: mapper.getIconName(location?.type?.icon),
            },
        style: {
          fillColor: cluster ? COLORS['base-800'] : '#fff',
          fillOpacity: 1,
          strokeColor: '#fff',
          strokeOpacity: 0.87,
          strokeWeight: 1,
        },
      },
      cluster,
    );

    this.defaultMapSource === 'google'
      ? this._handleGoogleLocationMarker()
      : this._handleEsriLocationMarker();

    this.location = location;
    this.setRotation(this.styles.rotation);
  }

  private _handleGoogleLocationMarker() {
    if (this.cluster) {
      const content = document.createElement('div');
      content.innerHTML = `
      <i class="fa-solid fa-city"></i>
      `;
      content.classList.add('fs__location-cluster-advanced-marker');
      (this.getMarker() as AdvancedMarkerElement).content = content;
      this.createBadge('fs__location-cluster-badge');
    } else {
      const icon = document.createElement('div');
      icon.innerHTML = `
      <i class="fa" id="fs__advanced-location-${this.location.id}">&#x${this.location.type.icon};</i>
      `;
      const faPinView = new google.maps.marker.PinElement({
        glyph: icon,
        glyphColor: colorIsDark(this.location.type?.color) ? COLORS['grey-0'] : '#000000',
        background: this.location.type.color,
        borderColor: this.location.type.color,
      });
      (this.getMarker() as AdvancedMarkerElement).content = faPinView.element;
    }
  }

  private _handleEsriLocationMarker() {}
}
